import Vue from "vue";
import VueRouter from "vue-router";
import storage from "@/utils/storage";
import store from "@/store";
import { ACCESS_TOKEN, CHOSE_SCHOOL } from "@/utils/mutation-types";

import Base from "./base";
import Common from "./common";
import schoolRouter from "./modules/school"; // 学校管理
import classListRouter from "./modules/classList"; // 年级管理
import teacherRouter from "./modules/teacher"; // 老师管理
import studentRouter from "./modules/student"; // 学生管理
import dormitoryRouter from "./modules/dormitory"; // 宿舍管理
import attendanceRouter from "./modules/attendance"; // 宿舍管理
import setRouter from "./modules/set"; // 系统设置
import err404 from "./err404"; // 404

import NProgress from "nprogress"; // progress bar
import "nprogress/nprogress.css"; // progress bar style
import BaseApi from "@/api/api/api_base.js";
import pubMsg from "@/utils/pubMsg";

Vue.use(VueRouter);
let router = new VueRouter({
  mode: "history",
  base: "/",
  routes: [...Common, ...Base],
});
const whiteList = ["login"]; // 免登录白名单

async function changeMenu() {
  const res = await BaseApi.findByToken();
  if (res.code == "200") {
    let oldRouter = JSON.parse(JSON.stringify(router.options.routes));
    if (res.data.accountType == "ADMIN") {
      oldRouter = [
        ...oldRouter,
        ...schoolRouter,
        ...dormitoryRouter,
        ...classListRouter,
        ...teacherRouter,
        ...studentRouter,
        ...attendanceRouter,
        ...setRouter,
        ...err404,
      ];
    } else if (res.data.accountType == "SCHOOL_ADMIN") {
      oldRouter = [
        ...oldRouter,
        ...dormitoryRouter,
        ...classListRouter,
        ...teacherRouter,
        ...studentRouter,
        ...attendanceRouter,
        ...err404,
      ];
    } else if (res.data.accountType == "TEACHER") {
      oldRouter = [
        ...oldRouter,
        ...studentRouter,
        ...attendanceRouter,
        ...err404,
      ];
    } else if (res.data.accountType == "DORM") {
      oldRouter = [
        ...oldRouter,
        ...dormitoryRouter,
        ...attendanceRouter,
        ...err404,
      ];
    }
    // console.log(findIndex)
    // console.log(oldRouter);
    router.addRoutes(oldRouter);
    store.commit("user/setUserInfo", res.data);
    store.commit("user/setUserId", res.data.id);
    store.commit(
      "user/setSchoolName",
      res.data.accountType != "ADMIN" ? res.data.schoolBasicList[0].name : ""
    );
    store.commit("setting/setMenu", oldRouter);
    store.commit("setting/setIsMenu", true);

    if (res.data.accountType == "ADMIN") {
      const chosedPro = storage.get(CHOSE_SCHOOL);
      console.log(chosedPro);
      store.commit("user/setSchoolId", chosedPro ? chosedPro.id : "");
      store.commit("user/setIsAdmin", true);
    } else {
      store.commit("user/setSchoolId", res.data.schoolId);
      store.commit("user/setIsAdmin", false);
    }
  } else {
    pubMsg.alert("服务错误，请稍后再试！");
  }
}

router.beforeEach(async (to, from, next) => {
  NProgress.start(); // start progress bar
  const path = to.path;
  const token = storage.get(ACCESS_TOKEN);
  // console.log(token);
  if (path == "/login") {
    // 此处不可使用location.replace
    // location.assign(to.fullPath)
    next();
    NProgress.done();
    return;
  } else {
    if (token) {
      const isStoreMenu = store.state.setting.isMenu;
      // console.log(isStoreMenu);
      if (isStoreMenu) {
        next();
        NProgress.done();
      } else {
        await changeMenu(next);
        // console.log(34);
        next({ ...to });
        NProgress.done();
      }
    } else {
      if (whiteList.includes(to.name)) {
        // 在免登录白名单，直接进入
        next();
      } else {
        next({ path: "/login" });
      }
      NProgress.done();
    }
  }
});

export default router;
